import { createRenderer } from '@main/core/bss-connector/js/render.js';
import { commonFunctions } from '../../../../../main-dxp/core/bss-connector/js/common/common-functions';
/**
 * Created by Katarzyna.Zabelska on 12.06.2019.
 * AMD Product Comparison initialization for QA - example run npm run dev:amd
 *
 * DON'T FORGET COPY init() & render() to config.js after modify.
 * Modify markets independent: PROD-DE
 *
 */
import { BSSController as BSSConnector } from './controller';
var sim = {
    BSSController: null,
    containerSelector: null,
    resolutionsConfig: {
        smMin: 1024,
        mdMin: 1200,
        lgMin: 1400,
    },
    elementType: 'productComparison',
    language: null,
    version: process.env.ENV_NAME,
    init: function (options) {
        var _a;
        if (typeof options.configuration === 'undefined') {
            console.warn('Product comparison configuration is not defined!');
            return;
        }
        if (sim.isInited) {
            console.log('Doubleclick - product comparison has been already inited');
            return;
        }
        sim.initOptions = options.configuration;
        if (sim.initOptions.Language) {
            sim.language = sim.initOptions.Language;
        }
        else {
            console.warn('Language is not defined!');
            return;
        }
        sim.environment = sim.initOptions.Environment || null;
        sim.gaKey = sim.initOptions.SessionKey || null;
        sim.configData = sim.prepareData(sim.initOptions);
        if (!options.target && options.target.tagName.toLowerCase() === 'body') {
            console.error(new Error('Target element is not specified! Please check options.target'));
            return;
        }
        var targetElement = options.target;
        if (((_a = options.target) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            targetElement = options.target[0];
        }
        if (!targetElement.id) {
            targetElement.id = "bss-entity-id-".concat(Math.random()
                .toString(32)
                .substring(2));
        }
        var selector = "#".concat(targetElement.id);
        sim.containerSelector = selector;
        sim.prepareLoader();
        sim.BSSController = new BSSConnector(sim.environment, sim.resolutionsConfig, sim.version, sim.elementType, sim.gaKey, null, {
            lang: sim.language,
            brand: sim.initOptions.Brand,
            country: sim.initOptions.Country,
        }, sim.initBSSListeners);
        if (sim.options) {
            sim.BSSController.setOptions(sim.options);
        }
        if (sim.initOptions) {
            sim.BSSController.setInitOptions(sim.initOptions);
        }
        sim.BSSController.setContainer('.bss-entity-container');
        sim.BSSController.initFlowWithParams(sim.configData);
        sim.isInited = true;
    },
    /**
     * @desc Initialize Loader in container.
     */
    prepareLoader: function () {
        var containerSelectorId = sim.containerSelector.substring(1);
        document
            .getElementById(containerSelectorId)
            .classList.add('bss-entity-container');
        document
            .getElementById(containerSelectorId)
            .classList.add('bss-entity-productComparison');
        if (typeof PreLoader !== 'undefined') {
            if (sim.containerSelector !== '#entity') {
                PreLoader.opts.containerId = containerSelectorId;
            }
            PreLoader.init();
        }
    },
    /**
     * @desc Create FLOW, add amd class to container, set params.
     */
    createFlow: function () {
        if (sim.containerSelector !== null) {
            sim.BSSController.setContainer(sim.containerSelector);
            document.querySelector(sim.containerSelector).classList.add('bss-amd');
        }
        document
            .querySelector(sim.containerSelector)
            .classList.add('bss-appended-to-body');
        var initialData = sim.prepareData(sim.initOptions);
        sim.BSSController.setParams(initialData);
        sim.BSSController.createFlow();
    },
    /**
     * @desc When entity are created remove loader, and initialize OA public listeners.
     */
    onEntityCreated: function () {
        if (typeof PreLoader !== 'undefined') {
            PreLoader.stop();
            if (typeof postal !== 'undefined') {
                postal.publish({
                    channel: 'com.toyota.tme.t1.finance',
                    topic: 'component.rendered',
                    data: {},
                });
            }
        }
    },
    /**
     * @desc Create flow.
     */
    onFlowConfigReady: function () {
        var configData = sim.configData;
        if (typeof sim.configData === 'undefined') {
            return;
        }
        sim.createFlow(configData);
    },
    /**
     * @desc Initialize all public Listeners
     */
    initBSSListeners: function () {
        document.addEventListener('bss-entity-created-' + sim.BSSController.flowId, sim.onEntityCreated);
        document.addEventListener('bss-flow-config-ready', sim.onFlowConfigReady);
        document.addEventListener('bss-destroy-connector-event', sim.onDestroyFlow);
    },
    /**
     * @desc Remove all Listeners and destroy Connector
     */
    onDestroyFlow: function () {
        if (!sim.BSSController) {
            return;
        }
        document.removeEventListener('bss-entity-created-' + sim.flowId, sim.onEntityCreated);
        document.removeEventListener('bss-flow-config-ready', sim.onFlowConfigReady);
        document.removeEventListener('bss-destroy-connector-event', sim.onDestroyFlow);
        sim.BSSController.destroyFlow();
        sim.BSSController = null;
        sim.isInited = false;
    },
    /**
     * @desc Change configuration only for what we support.
     * @param tempConfigData
     * @param configData
     * @returns {{country: 'no', ... }}
     */
    prepareData: function (tempConfigData) {
        var _a, _b;
        var allowedParams = commonFunctions.createListOfAllowedParams();
        var configData = tempConfigData
            ? commonFunctions.prepareConfigData(tempConfigData, allowedParams)
            : {};
        if (tempConfigData === null || tempConfigData === void 0 ? void 0 : tempConfigData.PSLS) {
            var PSLS = tempConfigData.PSLS;
            if ('Suffix' in PSLS) {
                var _c = PSLS.Suffix, Code = _c.Code, Katashiki = _c.Katashiki, AvailableFromDate = _c.AvailableFromDate, AvailableToDate = _c.AvailableToDate;
                configData.suffix = Code;
                configData.katashiki = Katashiki;
                configData.availableFromDate = AvailableFromDate;
                configData.availableToDate = AvailableToDate;
            }
            if ('LocalConfiguration' in PSLS) {
                configData.localCode = PSLS.LocalConfiguration.Code;
            }
        }
        if (tempConfigData.parameters) {
            configData.parameters = tempConfigData.parameters;
        }
        if (typeof ((_a = tempConfigData.Parameters) === null || _a === void 0 ? void 0 : _a.FinanceProductType) !== 'undefined') {
            configData.financeProductType =
                tempConfigData.Parameters.FinanceProductType;
        }
        if (typeof ((_b = tempConfigData.Parameters) === null || _b === void 0 ? void 0 : _b.FinanceQuoteID) !== 'undefined') {
            configData.quoteId = tempConfigData.Parameters.FinanceQuoteID;
        }
        if (tempConfigData.costs) {
            /**
             * @desc Data passed to the BE, FE does not care about the data content.
             * @example Can be found on FR NC Toyota.
             * @type {Record<string, string>[]}
             */
            configData.costs = JSON.stringify(tempConfigData.costs);
        }
        return configData;
    },
    render: render,
};
//expose a render method to the outside world
export var renderer = { render: sim.render, css: '' };
function render(options) {
    createRenderer().call(sim, options);
}
